module.exports = __webpack_public_path__ + "static/media/edutrace.41f4236e.png";